import gql from 'graphql-tag';

export default gql`
  mutation reviewHomeTaskMutation($lessonId: MongoID!, $status: String!) {
    reviewHomeTaskMutation(lessonId: $lessonId, status: $status) {
      title
      message
      _id
      id
      data {
        student
        course
        courseCategory
        homeTaskStatus
        isZeroLesson
      }
      workOnHomeTask {
        notes
      }
      homeTask {
        _id
        title
        notes
        filesStatuses {
          file
          status
          updatedAt
          updatedBy
        }
        files {
          _id
          name
          description
          interactionIcon
          path
          type
          data {
            isNotHandout
            isLink
          }
        }
      }
    }
  }
`;
